import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as SuccessIcon } from "../../../assets/Images/SuccessProjectIcon.svg";
import {
  getInsightsAction,
  getWorkflowsAction,
  workflowAction,
} from "../Actions/CommonActions";
import CommonPopup from "../CommonComponents/PopUpCards/CommonPopup";
import CustomParams from "./CustomParams";
import Insights from "./Insights";

const defaultFields = ["firstName", "lastName", "phone"];
export const defaultInsightFields = [
  {
    name: "callRecordingUrl",
    type: "default",
  },
  {
    name: "callStatus",
    type: "default",
  },
  {
    name: "mobileNo",
    type: "default",
  },
];

const Constants = () => {
  const dispatch = useDispatch();
  const [workflowInsights, setWorkflowInsights] = useState([]) as any;
  const [contactState, setContactState] = useState({
    contact: [""],
    loading: false,
  });
  const [state, setState] = useState<any>({
    questions: [{ name: "", type: "", key: "", question: "", insightType: "" }],
    errMsg: "",
    loading: false,
  });
  const [initialData, setInitialData] = useState<{
    insights: string[];
    contact: string[];
  }>({
    insights: [],
    contact: [],
  });
  const [successState, setSuccessState] = useState({
    successPopup: false,
    successPopupHeading: "",
    successPopupMessage: "",
  });
  const { successPopup, successPopupHeading, successPopupMessage } =
    successState;

  useEffect(() => {
    getWorkflowInsights();
    getWorkflowVariables();
  }, []);

  const getWorkflowInsights = async () => {
    const res: any = await dispatch(getInsightsAction());
    const allInsights: string[] = Array.from(
      new Set(
        res
          ?.flatMap((insight) => insight?.questions)
      )
    );

    setWorkflowInsights(allInsights);
  };

  const getWorkflowVariables = async () => {
    const res: any = await dispatch(getWorkflowsAction({ type: "variables" }));
    const varibales = res?.[0]?.data;
    const insights = varibales?.insights || [];
    const contacts = varibales?.contact || [];
    const filteredContacts = contacts.filter(
      (item) => !defaultFields.includes(item)
    );
    const filteredinsights = insights.filter(
      (item) => !defaultInsightFields.includes(item)
    );
    const updatedFields = [...defaultFields, ...filteredContacts];

    setInitialData({
      insights: varibales ? filteredinsights : defaultInsightFields,
      contact: updatedFields,
    });
    setContactState((prev) => ({
      ...prev,
      contact: updatedFields,
    }));

    setState((prev: any) => ({
      ...prev,
      questions: [
        { name: "", type: "", key: "", question: "", insightType: "" },
      ],
      insights: varibales ? filteredinsights : defaultInsightFields,
    }));
  };

  const handleInsightsSave = async (
    updatedInsights,
    isEdit = false,
    isDelete = false
  ) => {
    setState((prev) => ({
      ...prev,
      loading: !isDelete,
    }));

    const updatedInsight = [
      ...defaultInsightFields,
      ...updatedInsights.filter(
        (item) => !defaultInsightFields.some((def) => def.name === item.name)
      ),
    ];

    const data = {
      type: "variables",
      data: {
        insights: updatedInsight,
        contact: initialData?.contact,
      },
    };

    const res: any = await dispatch(workflowAction(data));
    if (res?.status === 200) {
      setSuccessState((prev) => ({
        ...prev,
        successPopup: true,
        successPopupHeading: isDelete
          ? "Insight Deleted"
          : isEdit
          ? "Insight Updated"
          : "Insights Saved",
        successPopupMessage: `Insight ${
          isDelete ? "Deleted" : isEdit ? "Updated" : "Saved"
        } Successfully`,
      }));

      setState((prev) => ({
        ...prev,
        loading: false,
        questions: [
          { name: "", type: "", key: "", question: "", insightType: "" },
        ],
        insights: updatedInsight,
        errMsg: "",
      }));

      setInitialData((prev) => ({
        ...prev,
        insights: updatedInsight,
      }));
    }
  };

  const handleCustomParamsSave = async (
    updatedContacts,
    isEdit = false,
    isDelete = false
  ) => {
    setContactState((prev) => ({
      ...prev,
      loading: !isDelete,
    }));
    const updatedParams = [
      ...defaultFields,
      ...Array.from(
        new Set([
          ...updatedContacts.filter((item) => !defaultFields.includes(item)),
        ])
      ),
    ];
    const data = {
      type: "variables",
      data: {
        insights: initialData?.insights,
        contact: updatedParams,
      },
    };

    const res: any = await dispatch(workflowAction(data));
    if (res?.status === 200) {
      setSuccessState((prev) => ({
        ...prev,
        successPopup: true,
        successPopupHeading: isDelete
          ? "Param Deleted"
          : isEdit
          ? "Param Updated"
          : "Params Saved",
        successPopupMessage: `Param ${
          isDelete ? "Deleted" : isEdit ? "Updated" : "Saved"
        } Successfully`,
      }));
      setContactState((prev) => ({
        ...prev,
        contact: updatedParams,
        loading: false,
      }));
      setInitialData((prev) => ({
        ...prev,
        contact: updatedParams,
      }));
    }
  };

  return (
    <>
      <Typography className="font-20-grey">Constants</Typography>

      <Box sx={{ py: 2, px: 1 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              variant="outlined"
              sx={{ height: "80vh" }}
              className="flex-column card"
            >
              <CardContent
                sx={{ flex: 1 }}
                className="flex-column overflow-hidden"
              >
                <Typography variant="h6" mb={0.5}>
                  Custom Parameters
                </Typography>
                <CustomParams
                  defaultFields={defaultFields}
                  contactState={contactState}
                  handleSave={handleCustomParamsSave}
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Card
              variant="outlined"
              sx={{ height: "80vh" }}
              className="flex-column card"
            >
              <CardContent
                sx={{ flex: 1 }}
                className="flex-column overflow-hidden"
              >
                <Typography variant="h6" mb={0.5}>
                  Insights
                </Typography>
                <Insights
                  workflowInsights={workflowInsights}
                  state={state}
                  setState={setState}
                  handleSave={handleInsightsSave}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {successPopup && (
          <CommonPopup
            message={successPopupMessage}
            show={successPopup}
            toggle={() =>
              setSuccessState((prev) => ({
                ...prev,
                successPopup: false,
                successPopupHeading: "",
                successPopupMessage: "",
              }))
            }
            Icon={SuccessIcon}
            heading={successPopupHeading}
          />
        )}
      </Box>
    </>
  );
};

export default Constants;
